import { render, staticRenderFns } from "./df-card-product.vue?vue&type=template&id=3cfc2353"
import script from "./df-card-product.ts?vue&type=script&lang=js&external"
export * from "./df-card-product.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports